import { render, staticRenderFns } from "./MiColegiatura.vue?vue&type=template&id=2b6e3aa6&scoped=true"
import script from "./MiColegiatura.vue?vue&type=script&lang=js"
export * from "./MiColegiatura.vue?vue&type=script&lang=js"
import style0 from "./MiColegiatura.vue?vue&type=style&index=0&id=2b6e3aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e3aa6",
  null
  
)

export default component.exports